import { COMPANY } from "../data/content";

export default function MapComponent({ compact = false, fullHeight = false }) {
  return (
    <div className={`w-full overflow-hidden rounded-2xl bg-white border border-sand-300 shadow-xs ${fullHeight ? "h-full flex flex-col" : ""}`}>
      <div className="p-4 sm:p-5 bg-forest-900 text-white flex flex-col sm:flex-row items-start sm:items-center justify-between gap-3 shrink-0">
        <div className="flex items-center gap-3">
          <div className="w-10 h-10 rounded-full bg-forest-700 flex items-center justify-center shrink-0 text-sand-200">
            <i className="fa-solid fa-map-location-dot text-lg"></i>
          </div>
          <div>
            <h4 className="font-semibold text-sand-50 text-base leading-snug">
              Dækningsområde: Hele Jylland
            </h4>
            <p className="text-xs text-sand-200/90 mt-0.5">
              Udkørende hovtrimmer med base i Lemvig
            </p>
          </div>
        </div>
        <div className="text-xs bg-forest-800 border border-forest-600/50 text-sand-100 px-3 py-1.5 rounded-full font-medium shrink-0">
          <i className="fa-solid fa-car text-emerald-400 mr-1.5"></i> Kører ud til din stald
        </div>
      </div>

      {/* Map display - Zoomed out to show all Jutland / Denmark at once */}
      <div className={`relative w-full ${fullHeight ? "flex-1 min-h-[320px]" : compact ? "h-64 sm:h-72" : "h-80 sm:h-96"} bg-sand-100`}>
        {/* Google Maps iFrame zoomed out over Jutland / Denmark */}
        <iframe
          title="Hoofcare Jylland Dækningsområde"
          className="w-full h-full border-0 filter grayscale-[15%] contrast-[105%]"
          src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2800000.0000000000!2d8.5000000!3d56.2000000!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x464b20a3203f5c7d%3A0xd64f1d43eb402778!2sJylland!5e0!3m2!1sda!2sdk!4v1700000000000!5m2!1sda!2sdk"
          allowFullScreen=""
          loading="lazy"
          referrerPolicy="no-referrer-when-downgrade"
        ></iframe>

        {/* Coverage overlay banner */}
        <div className="absolute bottom-3 left-3 right-3 sm:left-4 sm:right-auto sm:max-w-md bg-forest-950/90 backdrop-blur-md text-white p-3.5 rounded-xl shadow-lg border border-forest-700/50">
          <div className="flex items-start gap-2.5">
            <i className="fa-solid fa-circle-check text-emerald-400 text-sm mt-0.5"></i>
            <div>
              <p className="text-xs sm:text-sm font-medium text-sand-50 leading-relaxed">
                {COMPANY.coverageText}
              </p>
              <div className="mt-1.5 flex flex-wrap items-center gap-x-3 text-[11px] text-sand-200">
                <span><i className="fa-solid fa-location-dot text-amber-400 mr-1"></i> {COMPANY.address}, {COMPANY.city}</span>
                <a 
                  href={`tel:${COMPANY.phoneRaw}`} 
                  className="hover:text-white transition-colors whitespace-nowrap font-medium"
                >
                  <i className="fa-solid fa-phone text-emerald-400 mr-1"></i>
                  <span className="whitespace-nowrap">{COMPANY.phone}</span>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
